export const sectionsByCourseIdSelector = state => state.entities.sections.byCourseId;
